export class UpdateCreditCardExpirationRequest {
  CreditCardID: number;
  ExpMonth: number;
  ExpYear: number;
  Zipcode: string;
  IsDefault?: boolean;
}
